var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { observable, makeObservable } from 'mobx';
export class BaseMandate {
    constructor() {
        Object.defineProperty(this, "redisId", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "mandates", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: []
        });
        Object.defineProperty(this, "isVisible", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: (customer) => {
                return this.doesNotBelongToRepresentativeCustomer(customer) && this.getVisibleMandates().length > 0;
            }
        });
        Object.defineProperty(this, "getVisibleMandates", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: () => {
                const legalMandate = this.mandates.find((mandate) => mandate.isLegal());
                if (legalMandate) {
                    return [legalMandate];
                }
                return [MandateType.SERVICE, MandateType.BILLING, MandateType.SERVICE_USAGE_DISTINCTION]
                    .map((mandateType) => this.mandates.find((mandate) => mandate.type === mandateType && mandate.isDiilMandate()))
                    .filter((mandate) => mandate);
            }
        });
        makeObservable(this);
    }
}
__decorate([
    observable
], BaseMandate.prototype, "redisId", void 0);
__decorate([
    observable
], BaseMandate.prototype, "mandates", void 0);
export var CommunicationLanguage;
(function (CommunicationLanguage) {
    CommunicationLanguage["EN"] = "EN";
    CommunicationLanguage["ET"] = "ET";
    CommunicationLanguage["RU"] = "RU";
})(CommunicationLanguage || (CommunicationLanguage = {}));
export const communicationLanguages = [CommunicationLanguage.ET, CommunicationLanguage.EN, CommunicationLanguage.RU];
export var MandateType;
(function (MandateType) {
    MandateType["SELF"] = "SELF";
    MandateType["LEGAL"] = "LEGAL";
    MandateType["GOODS"] = "GOODS";
    MandateType["BILLING"] = "BILLING";
    MandateType["SERVICE"] = "SERVICE";
    MandateType["SERVICE_USAGE_DISTINCTION"] = "SERVICE_USAGE_DISTINCTION";
    MandateType["USER"] = "USER";
})(MandateType || (MandateType = {}));
export var MandateQueryType;
(function (MandateQueryType) {
    MandateQueryType["CUSTOMER_MANDATES"] = "customer-mandates";
    MandateQueryType["PERSON_MANDATES"] = "person-mandates";
    MandateQueryType["REMOVE_PERSON_MANDATE"] = "remove-person-mandate";
})(MandateQueryType || (MandateQueryType = {}));
